import classNames from "classnames";
import styles from "../styles.module.scss";
import { useSetAtom } from "jotai";
import { conferenceStep } from "../../../../state";
import { Field, FormikValues, useFormikContext } from "formik";
import { useQuery } from "@tanstack/react-query";
import {
  EventIdType,
  getEventCategories,
  getEventsByCategory,
} from "../../../../requests";
import Select from "../../../../custom/select/select";
import Button from "../../../../custom/button/button";

enum EventType {
  Training = 1,
  Conference = 2,
  Other = 3,
}

const SelectConference = () => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const setStep = useSetAtom(conferenceStep);

  const eventCategories = useQuery({
    queryKey: ["get-event-categories"],
    queryFn: getEventCategories,
  });
  const eventByCategory = useQuery({
    queryKey: ["get-event-by-category", values.conferenceType],
    queryFn: () => getEventsByCategory(parseInt(values.conferenceType)),
    enabled: !!values.conferenceType,
  });

  const categoryData = eventCategories?.data?.Data as EventCategory[];
  const eventData = eventByCategory?.data?.Data as EventByCategory[];

  const eventCategoryOptions = categoryData
    ?.filter(
      (x) => x.EventTypeId === EventType.Conference && x.ActiceStatus === true
    )
    ?.map((item) => (
      <option key={item.Id} value={item.Id}>
        {item.EventCategoryName}
      </option>
    ));
  const eventsByCategoryOptions = eventData
    ?.filter((x) => x.EventTypeId === EventIdType.Conference)
    ?.map((item, index) => (
      <option
        key={index}
        value={`{"eventNameId": ${item.EventNameId}, "learningEventId": ${item.LearningEventId}}`}
      >
        {item.EventName}
      </option>
    ));

  const nextStep = () => {
    if (values.conferenceName) {
      const details = JSON.parse(values.conferenceName);
      setFieldValue("conferenceName", details?.eventNameId);
      setFieldValue("learningEventId", parseInt(details?.learningEventId));
      //setFieldValue("amount", parseInt(details?.amount));
      setStep((prev) => prev + 1);
    }
  };

  return (
    <div className={styles.formBody}>
      <section className={styles.grid}>
        <Field
          name="conferenceType"
          as={Select}
          label="Conference Theme"
          placeholder="Select"
          options={eventCategoryOptions}
          isLoading={eventCategories.isLoading}
        />
        <Field
          name="conferenceName"
          as={Select}
          label="Conference Type"
          placeholder="Select"
          options={eventsByCategoryOptions}
          isLoading={eventByCategory.isLoading}
        />
      </section>
      <br />
      <br />
      <div className={styles.buttonGroup}>
        <Button text="Cancel" className={classNames("cancelBtn")} />
        <Button onClick={nextStep} type="button" text="Proceed" />
      </div>
    </div>
  );
};

export default SelectConference;
